import {mapState} from "vuex";

export default {
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["generalQueryObject"])
  },
  data() {
    return {
      calendarsArray: [
        "last_modified_na_from",
        "last_modified_na_to",
        "last_modified_lead_from",
        "last_modified_lead_to",
        "registered_on_from",
        "registered_on_to",
        "deposit_at_from",
        "deposit_at_to",
        "assigned_at_from",
        "assigned_at_to",
        "last_modified_from",
        "last_modified_to",
        "last_modified_personal_from",
        "last_modified_personal_to",
        "last_transfer_from",
        "last_transfer_to",
        "scheduled_call_to_from",
        "scheduled_call_to_to",
        "last_referral_from",
        "last_referral_to",
        "support_at_from",
        "support_at_to",
        "group_assigned_at_from",
        "group_assigned_at_to"
      ]
    };
  },
  methods: {
    //check if calendar range is selected
    checkIfCalendarSelected() {
      let res = false;

      this.calendarsArray.map(key => {
        if (this.generalQueryObject.hasOwnProperty(key)) {
          res = true;
        }
      });
      return res;
    },

    checkNumbersOfCalendarsSelected() {
      let num = 0;

      this.calendarsArray.map(key => {
        if (this.generalQueryObject.hasOwnProperty(key)) {
          num++;
        }
      });
      if (num > 0) {
        num = num / 2;
      }
      return num;
    }
  }
};
